// extracted by mini-css-extract-plugin
module.exports = {"main_color":"#009ccc","menu_container":"DrawerMenu-module--menu_container--6uyA-","icon":"DrawerMenu-module--icon--3iZqu"};